export default "__VITE_ASSET__bZJXLxPD__"